import {Component, effect, inject, resource, untracked} from '@angular/core';
import {ObservationManagementService} from '../../../../../data/observations/observation-management.service';
import {RowWithSelectComponent} from '../../row-with-select/row-with-select.component';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {NgTemplateOutlet} from '@angular/common';
import {Router} from '@angular/router';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';
import {CartegraphManagementService} from '../../../../../data/cartegraph/cartegraph-management.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  CartegraphObservationMapping,
  CartegraphObservationSettings
} from '../../../../../shared/models/cartegraph.model';


@Component({
  selector: 'app-cartegraph-settings-observations',
  templateUrl: './cartegraph-settings-observations-mapping.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss'],
  imports: [
    RowWithSelectComponent,
    CardComponent,
    NgTemplateOutlet,
    CardContentDirective,
    MatProgressSpinner,
    ReactiveFormsModule
  ],
  standalone: true
})
export class CartegraphSettingsObservationsMappingComponent {

  private cartegraphManagementService = inject(CartegraphManagementService);
  private observationManagementService = inject(ObservationManagementService);
  private router = inject(Router);
  private fb = inject(FormBuilder);


  uiError: string;

  selectionsGroup = new FormGroup<{ [key: string]: FormControl<string | null> }>({});
  form = this.fb.group({
    selections: this.selectionsGroup,
  });

  private configResource = resource({
    loader: async () => (await this.cartegraphManagementService.getConfiguration()).data
  });
  observationResource = resource({
    params: () => {
      const config = this.configResource.value();
      // return undefined if still waiting!
      if (!!config) {
        return {config};
      } else {
        return undefined;
      }
    },
    loader: async ({params}) => {
      const typeGroups = await this.observationManagementService.getObservationTypeGroups();

      typeGroups.forEach(group => {
        // sort types by title
        if (group.observationTypes != null && group.observationTypes.length > 0) {
          group.observationTypes = group.observationTypes.sort((a, b) => a.title.localeCompare(b.title));
        }

      });

      return typeGroups.filter(
        group => params.config.settings?.observations?.excludedObservationGroups?.find(f => f === group.id) === undefined
      );
    },
    defaultValue: []
  });
  activityResource = resource({
    loader: () => this.cartegraphManagementService.getActivityList(true)
  });


  constructor() {

    effect(() => {
      const groups = this.observationResource.value();
      if (!groups) {
        return;
      }

      untracked(() => {
        groups.forEach(group => {
          group.observationTypes.forEach(type => {
            const mappedActivityOid = this.configResource.value()
              .settings.observations?.activityMapping?.find(m => m.typeId === type.id)?.activityOid;
            this.selectionsGroup.addControl(group.id + '_' + type.id, new FormControl(mappedActivityOid), {emitEvent: false});
          });
        });
      });
    });

    // listen for changes on selections
    this.selectionsGroup.valueChanges.subscribe(values => {
      const mapping = Object.keys(values)
        .filter(i => values[i] !== undefined && values[i] !== null && values[i] !== '')
        .map(key => {
          const typeId = +key.substring(key.lastIndexOf('_') + 1);
          const activityOid = values[key];
          return {typeId, activityOid} as CartegraphObservationMapping;
        });
      this.updateConfiguration(mapping);
    });

  }

  updateConfiguration(mapping: CartegraphObservationMapping[]) {
    const observations = this.configResource.value().settings.observations ?? new CartegraphObservationSettings();
    observations.activityMapping = mapping;
    this.cartegraphManagementService.updateObservations(observations).then(response => {
      if (!!response.error) {
        this.uiError = response.error;
      } else {
        // this.configResource.reload(); // only if we want to reload the config
      }
    }).catch(error => {
      console.error(error);
      this.uiError = error;
    });
  }

  protected navigateBack() {
    this.router.navigate(['settings/cartegraph-settings/settings/features']).then();
  }
}
